import React from "react";
import EcomStep from "./constants/ecom-step";
import { getPrimarySteps } from "./ecom-step-transitions";
import TimelineItem from "./ecom-timeline-item";
const getLabel = (step) => {
    switch (step) {
        case EcomStep.TRADE_IN_EXISTS_CHOOSER:
            return "Inbyte";
        case EcomStep.PAYMENT_METHOD_CHOOSER:
            return "Finansiering";
        case EcomStep.CREDIT_ASSESSMENT_INFORMATION:
        case EcomStep.BANKID_AUTHENTICATION:
        case EcomStep.CUSTOMER_INFORMATION_INITIAL:
            return "Uppgifter";
        case EcomStep.INSURANCE_INFORMATION_DEFINITION:
            return "Försäkring";
        case EcomStep.ACCESSORIES_CHOOSER:
            return "Tillbehör";
        case EcomStep.DELIVERY_METHOD:
            return "Leverans";
        case EcomStep.FINAL_SUMMARY:
            return "Sammanställning";
        case EcomStep.FINAL_CONFIRMATION:
            return "Bekräftelse";
        default:
            return "";
    }
};
export default (props) => {
    if (!props.options) {
        return React.createElement("div", null);
    }
    const primarySteps = getPrimarySteps(props.options, props.useBankId);
    const items = [];
    let timelineItemKey = 0;
    for (let i = 0; i < primarySteps.length; i += 1) {
        const primaryStep = primarySteps[i];
        const nextStepIndex = i + 1;
        const nextStep = nextStepIndex < primarySteps.length
            ? primarySteps[nextStepIndex]
            : null;
        const label = getLabel(primaryStep);
        const fullLabel = label ? `${i + 1}. ${label}` : null;
        let isActive;
        let isInbetweenStepActive;
        if (nextStep) {
            isActive =
                props.currentStep >= primaryStep &&
                    props.currentStep < nextStep;
            isInbetweenStepActive =
                props.currentStep > primaryStep && props.currentStep < nextStep;
        }
        else {
            isActive = props.currentStep === primaryStep;
            isInbetweenStepActive = false;
        }
        items.push(React.createElement(TimelineItem, { key: timelineItemKey, label: fullLabel, isActive: isActive, isInbetweenStepActive: isInbetweenStepActive }));
        timelineItemKey += 1;
        if (nextStep) {
            items.push(React.createElement("li", { key: timelineItemKey, className: "timeline-item timeline-item-step" },
                React.createElement("div", { className: "timeline-indicator" })));
            timelineItemKey += 1;
        }
    }
    return (React.createElement("div", { "data-ecom-timeline": "" },
        React.createElement("div", { className: "timeline" },
            React.createElement("ul", { className: "timeline-list" }, items))));
};
